import { PatientDataSource } from "./PatientDataSource";
import { ApiService } from "@/domain/clients";
import { Endpoints } from "@/infra/api";
import { NotFoundError } from "@/domain/errors";
import {
  PatientDetailsResponse,
  PatientsResponse,
} from "@/data/dtos/responses";

export class PatientRemoteDataSource implements PatientDataSource {
  constructor(private readonly api: ApiService) {}

  async getPatients(): Promise<PatientsResponse> {
    const { data } = await this.api.get<PatientsResponse>(Endpoints.patients);

    if (!data) {
      return {
        single: [],
        recurrent: [],
      };
    }

    return data;
  }

  async getPatientById(id: number): Promise<PatientDetailsResponse> {
    const { data } = await this.api.get<PatientDetailsResponse>(
      `${Endpoints.patients}/${id}`,
    );

    if (!data) {
      throw new NotFoundError("Paciente");
    }

    return data;
  }
}
